"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGN_OUT_FAILED_COPY = exports.SIGN_OUT_FAILED_TITLE_COPY = exports.AUTH_NETWORK_ERROR_COPY = void 0;
exports.isClerkNetworkError = isClerkNetworkError;
exports.isSwallowedClerkResult = isSwallowedClerkResult;
/**
 * What every client says when an auth request never reached Clerk (BEN-141 FP-174,
 * wording agreed by web and mobile, 2026-10-07).
 *
 * clerk-js RESOLVES such a request with an empty resource: `BaseResource._baseFetch`
 * returns null when it thinks the device is offline ("Network request failed while
 * offline, returning null"), and `fromJSON(null)` leaves a resource with no id. React
 * Native has no `navigator.onLine`, so every RN network failure did it; a browser does it
 * when genuinely offline. The forgot-password screens then said a code had been sent.
 *
 * Fixed with `rethrowOfflineNetworkErrors` on each ClerkProvider: an offline sign-out that
 * looked done came back on relaunch (mobile, D5), and detecting the empty result misses
 * after any earlier attempt, because clerk-js reuses one SignIn object and a null
 * response leaves it unchanged (mobile, R2). `isSwallowedClerkResult` is the backstop for
 * a fresh client if the option is ever off.
 */
exports.AUTH_NETWORK_ERROR_COPY = "Couldn't reach Fomo-Fi. Check your connection and try again.";
/**
 * Whether a thrown value is Clerk's "never reached the server" error. The rethrow is a
 * ClerkRuntimeError with `code` ON THE ERROR and no `errors[]` array, so a check that
 * reads `errors[0].code` (an API error's shape) never sees it. Mobile's review caught
 * exactly that before either client shipped.
 */
function isClerkNetworkError(err) {
    return (typeof err === "object" &&
        err !== null &&
        err.code === "network_error");
}
/**
 * BACKSTOP ONLY: whether an auth call "succeeded" without reaching Clerk on a FRESH
 * client (the empty resource has no id). It cannot see a swallowed retry after an
 * earlier attempt: clerk-js reuses one SignIn object and keeps that attempt's id (R2).
 * The thrown `network_error` from `rethrowOfflineNetworkErrors` is the real signal.
 */
function isSwallowedClerkResult(res) {
    return !res || !res.id;
}
/**
 * Sign-out that couldn't reach Clerk (FP-174, mobile's wording). Before the clients
 * turned on `rethrowOfflineNetworkErrors`, an offline sign-out LOOKED done and the
 * session came back on the next online launch (mobile, Android, D5); now it fails, and
 * these say so. Two keys because mobile shows an alert title and body; web joins them.
 */
exports.SIGN_OUT_FAILED_TITLE_COPY = "Couldn't sign out";
exports.SIGN_OUT_FAILED_COPY = "You're still signed in. Check your connection and try again.";
//# sourceMappingURL=authNetworkCopy.js.map